import { render, staticRenderFns } from "./RateUs.component.vue?vue&type=template&id=1d3966e8&"
import script from "./RateUs.component.vue?vue&type=script&lang=ts&"
export * from "./RateUs.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports